(() => {
  'use strict';
  const configNode = document.getElementById('lr-review-form-config');
  const form = document.getElementById('lr-review-form');
  if (!configNode || !form) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  let invalidVerificationLink = false;
  function captureVerificationToken() {
    try {
      const current = new URL(location.href);
      const fragment = new URLSearchParams(current.hash.slice(1));
      const fromFragment = fragment.has('reviewVerification');
      const candidates = fromFragment ? fragment.getAll('reviewVerification') : current.searchParams.getAll('verificationToken');
      const candidate = candidates[0] || '';
      const present = fromFragment || current.searchParams.has('verificationToken');
      const valid = candidates.length === 1 && candidate.length <= 3000 && /^[A-Za-z0-9_-]+\.[a-fA-F0-9]{64}$/.test(candidate);
      invalidVerificationLink = present && !valid;
      const hasFragmentToken = fragment.has('reviewVerification') || fragment.has('verificationToken');
      const hasQueryToken = current.searchParams.has('verificationToken') || current.searchParams.has('reviewVerification');
      if (hasFragmentToken || hasQueryToken) {
        current.searchParams.delete('verificationToken'); current.searchParams.delete('reviewVerification');
        if (hasFragmentToken) {
          fragment.delete('reviewVerification'); fragment.delete('verificationToken');
          current.hash = fragment.toString();
        }
        // Replace the current history entry; preserve view, preview and unrelated URL parameters.
        // The captured token remains only in this form closure, never storage, attributes or links.
        try { history.replaceState(history.state, '', current.pathname + current.search + current.hash); } catch (_) { /* No token is added to any outgoing link even if history is unavailable. */ }
      }
      return present && valid ? candidate : null;
    } catch (_) { invalidVerificationLink = true; return null; }
  }
  // End verification URL boundary.
  let verificationToken = captureVerificationToken();
  const $ = (id) => document.getElementById(id);
  const fields = { title: $('lr-title'), body: $('lr-description'), reviewerName: $('lr-name'), email: $('lr-email') };
  const errors = { rating: $('lr-rating-error'), title: $('lr-title-error'), body: $('lr-description-error'), reviewerName: $('lr-name-error'), email: $('lr-email-error') };
  const attachments = [];
  let avatar = null;
  let busy = false;
  let receipt = null;
  let pendingMedia = 0;
  const uuid = () => {
    if (crypto.randomUUID) return crypto.randomUUID();
    const values = crypto.getRandomValues(new Uint8Array(16));
    values[6] = (values[6] & 15) | 64; values[8] = (values[8] & 63) | 128;
    const h = [...values].map((v) => v.toString(16).padStart(2, '0')).join('');
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
  };
  let visitorId = uuid();
  try {
    const previous = localStorage.getItem('luscent-review-visitor');
    if (previous && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(previous)) visitorId = previous;
    else localStorage.setItem('luscent-review-visitor', visitorId);
  } catch (_) { /* Reviews remain usable when browser storage is disabled. */ }
  const submissionId = uuid();
  const allowedImageTypes = new Set(['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif']);
  const allowedVideoTypes = new Set(['video/mp4', 'video/webm', 'video/quicktime', 'video/x-m4v', 'video/m4v', 'video/x-matroska', 'video/matroska', 'video/x-msvideo', 'video/avi']);
  const extensionTypes = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp', heic: 'image/heic', heif: 'image/heif', mp4: 'video/mp4', mov: 'video/quicktime', m4v: 'video/x-m4v', webm: 'video/webm', mkv: 'video/x-matroska', avi: 'video/x-msvideo' };
  const maxImageBytes = Number(config.maxImageBytes) || 31457280;
  const maxVideoBytes = Number(config.maxVideoBytes) || 31457280;
  const maxAttachments = Math.min(20, Number(config.maxAttachments) || 20);
  let backend = null;
  try {
    const base = new URL(config.backendBaseUrl, location.origin);
    if (/^https:$/.test(base.protocol) && !String(config.backendBaseUrl).includes('__')) backend = base;
    else if (['localhost', '127.0.0.1'].includes(location.hostname) && base.hostname === location.hostname) backend = base;
  } catch (_) { /* An unconfigured draft never sends reviews to a guessed service. */ }
  const endpoint = (path) => new URL(path, backend).href;
  function showMessage(element, text) {
    element.textContent = text || '';
    element.hidden = !text;
  }
  function fieldError(name, text) {
    const node = errors[name];
    if (!node) return;
    showMessage(node, text);
    if (name === 'rating') {
      form.querySelector('.lr-rating').classList.toggle('has-error', Boolean(text));
      form.querySelectorAll('[name="rating"]').forEach((input) => input.setAttribute('aria-invalid', text ? 'true' : 'false'));
    } else {
      fields[name].setAttribute('aria-invalid', text ? 'true' : 'false');
      fields[name].closest('.lr-field').classList.toggle('has-error', Boolean(text));
    }
  }
  function errorSummary(message, focus = true) {
    showMessage($('lr-form-errors'), message);
    if (message && focus) $('lr-form-errors').focus();
  }
  function setBusy(value) {
    busy = value;
    form.setAttribute('aria-busy', String(value));
    $('lr-submit').disabled = value || Boolean(receipt) || pendingMedia > 0;
    if (value) $('lr-submit').textContent = receipt ? 'Uploading...' : 'Submitting...';
    else $('lr-submit').textContent = receipt ? 'Review received' : 'Agree & Submit';
    form.querySelectorAll('input,textarea,.lr-preview-remove,.lr-avatar-remove').forEach((node) => { node.disabled = value || Boolean(receipt); });
    $('lr-retry-uploads').disabled = value;
    $('lr-finish-without-media').disabled = value;
  }
  const rating = () => Number(form.querySelector('[name="rating"]:checked')?.value || 0);
  const starFill = form.querySelector('.lr-rating-filled');
  const paintStars = (value) => { starFill.style.width = `${Math.max(0, Math.min(5, Number(value))) * 20}%`; };
  form.querySelectorAll('[name="rating"]').forEach((input) => {
    input.addEventListener('change', () => { paintStars(rating()); fieldError('rating', ''); });
  });
  form.querySelectorAll('[data-rating]').forEach((label) => {
    label.addEventListener('pointerenter', () => { if (!busy && !receipt) paintStars(label.dataset.rating); });
  });
  form.querySelector('.lr-rating-inner').addEventListener('pointerleave', () => paintStars(rating()));
  Object.entries(fields).forEach(([name, input]) => input.addEventListener('input', () => fieldError(name, '')));
  const dispose = (item) => { if (item?.previewUrl) URL.revokeObjectURL(item.previewUrl); };
  function removeAttachment(id) {
    if (busy || receipt) return;
    const index = attachments.findIndex((item) => item.id === id);
    if (index >= 0) dispose(attachments.splice(index, 1)[0]);
    if (attachments.length < maxAttachments) showMessage($('lr-media-error'), '');
    renderAttachments();
  }
  function renderAttachments() {
    const container = $('lr-media-previews');
    container.replaceChildren();
    container.hidden = !attachments.length;
    const upload = container.closest('.lr-review-upload');
    upload.classList.toggle('has-media', Boolean(attachments.length));
    upload.querySelector('.lr-upload-label').hidden = Boolean(attachments.length);
    attachments.forEach((item) => {
      const figure = document.createElement('figure'); figure.className = 'lr-preview';
      const media = document.createElement(item.kind === 'video' ? 'video' : 'img');
      media.src = item.previewUrl;
      if (item.kind === 'video') { media.preload = 'metadata'; media.playsInline = true; media.muted = true; }
      else media.alt = item.file.name;
      media.addEventListener('error', () => {
        media.hidden = true;
        const fallback = document.createElement('span'); fallback.className = 'lr-preview-fallback';
        fallback.textContent = item.kind === 'video' ? 'Video' : 'Photo';
        fallback.setAttribute('aria-label', 'Preview available after upload'); figure.prepend(fallback);
      }, { once: true });
      const remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'lr-preview-remove'; remove.textContent = '\u00d7';
      remove.setAttribute('aria-label', `Remove ${item.file.name}`); remove.disabled = busy || Boolean(receipt);
      remove.addEventListener('click', () => removeAttachment(item.id));
      const caption = document.createElement('figcaption');
      caption.className = 'lr-sr-only';
      caption.textContent = item.uploaded ? `${item.file.name} - uploaded` : item.file.name;
      figure.append(media, remove, caption); container.append(figure);
    });
    if (attachments.length && attachments.length < maxAttachments && !receipt) {
      const add = document.createElement('label');
      add.className = 'lr-add-media'; add.htmlFor = 'lr-media'; add.textContent = '+';
      add.setAttribute('aria-label', 'Add more photos or videos'); container.append(add);
    }
  }
  function renderAvatar() {
    const icon = $('lr-avatar-icon');
    icon.querySelectorAll('img').forEach((node) => node.remove());
    const svg = icon.querySelector('svg');
    if (svg) svg.hidden = Boolean(avatar);
    if (avatar) {
      const image = document.createElement('img'); image.src = avatar.previewUrl; image.alt = 'Profile picture preview'; image.className = 'lr-avatar-image';
      image.addEventListener('error', () => { image.remove(); if (svg) svg.hidden = false; icon.setAttribute('title', 'Preview available after upload'); }, { once: true });
      icon.append(image);
    }
    $('lr-avatar-remove').hidden = !avatar;
  }
  async function previewDuration(file) {
    return new Promise((resolve) => {
      const video = document.createElement('video');
      const source = URL.createObjectURL(file);
      let settled = false;
      const timer = setTimeout(() => done(null), 4000);
      const done = (duration) => { if (settled) return; settled = true; clearTimeout(timer); video.removeAttribute('src'); video.load(); URL.revokeObjectURL(source); resolve(duration); };
      video.preload = 'metadata'; video.onloadedmetadata = () => done(Number.isFinite(video.duration) ? video.duration : null);
      // MKV/AVI/MOV browser previews may be unsupported; the decoder on the server remains authoritative.
      video.onerror = () => done(null); video.src = source;
    });
  }
  async function addFiles(files, kind) {
    if (busy || receipt) return;
    pendingMedia++;
    $('lr-submit').disabled = true;
    try {
    const failures = [];
    for (const original of Array.from(files)) {
      const inferredType = extensionTypes[original.name.toLowerCase().split('.').pop()];
      const type = allowedImageTypes.has(original.type) || allowedVideoTypes.has(original.type) ? original.type : inferredType || original.type;
      const file = type !== original.type ? new File([original], original.name, { type, lastModified: original.lastModified }) : original;
      const isVideo = allowedVideoTypes.has(file.type);
      const isImage = allowedImageTypes.has(file.type);
      if (!isImage && (kind === 'avatar' || !isVideo)) { failures.push('Please use JPEG, PNG, HEIC or HEIF photos, or MP4, MOV, M4V, WebM, MKV or AVI videos.'); continue; }
      if (!file.size || (kind !== 'avatar' && file.size < 125)) { failures.push('The file is too small. Please choose a complete photo or video.'); continue; }
      if (file.size > (isVideo ? maxVideoBytes : maxImageBytes)) { failures.push(isVideo ? `Videos must be ${Math.round(maxVideoBytes / 1048576)} MB or smaller.` : `Images must be ${Math.round(maxImageBytes / 1048576)} MB or smaller.`); continue; }
      if (isVideo) {
        const duration = await previewDuration(file);
        if (duration !== null && duration < 1) { failures.push('Videos must be at least 1 second long.'); continue; }
      }
      if (busy || receipt) return;
      if (kind !== 'avatar' && attachments.length >= maxAttachments) { failures.push(`You can add up to ${maxAttachments} photos or videos.`); break; }
      if (kind !== 'avatar' && attachments.some((item) => item.file.name === file.name && item.file.size === file.size && item.file.lastModified === file.lastModified)) continue;
      const item = { id: uuid(), file, kind: kind === 'avatar' ? 'avatar' : isVideo ? 'video' : 'image', previewUrl: URL.createObjectURL(file), uploaded: false };
      if (kind === 'avatar') { dispose(avatar); avatar = item; break; }
      attachments.push(item);
    }
    if (kind === 'avatar') renderAvatar(); else renderAttachments();
    showMessage($(kind === 'avatar' ? 'lr-avatar-error' : 'lr-media-error'), [...new Set(failures)].join(' '));
    } finally {
      pendingMedia--;
      $('lr-submit').disabled = busy || Boolean(receipt) || pendingMedia > 0;
    }
  }
  [['lr-media', 'media'], ['lr-avatar', 'avatar']].forEach(([id, kind]) => {
    $(id).addEventListener('change', (event) => { addFiles(event.target.files || [], kind); event.target.value = ''; });
  });
  form.querySelectorAll('[data-drop]').forEach((zone) => {
    let depth = 0;
    zone.addEventListener('dragenter', (event) => { event.preventDefault(); depth++; if (!busy && !receipt) zone.classList.add('is-dragging'); });
    zone.addEventListener('dragover', (event) => event.preventDefault());
    zone.addEventListener('dragleave', () => { depth = Math.max(0, depth - 1); if (!depth) zone.classList.remove('is-dragging'); });
    zone.addEventListener('drop', (event) => { event.preventDefault(); depth = 0; zone.classList.remove('is-dragging'); addFiles(event.dataTransfer?.files || [], zone.dataset.drop); });
  });
  $('lr-avatar-remove').addEventListener('click', () => { if (busy || receipt) return; dispose(avatar); avatar = null; renderAvatar(); });
  function validate() {
    let valid = true;
    const check = (name, message) => { fieldError(name, message); if (message) valid = false; };
    check('rating', rating() ? '' : 'Please select a star rating.');
    check('title', fields.title.value.trim() ? '' : 'Please enter a review title.');
    check('body', fields.body.value.trim() ? '' : 'Please enter your review description.');
    check('reviewerName', fields.reviewerName.value.trim() ? '' : 'Please enter your name.');
    check('email', /^[^\s@<>]+@[^\s@<>]+\.[A-Za-z]{2,}$/.test(fields.email.value.trim()) ? '' : 'Please enter a valid email address.');
    form.querySelectorAll('[data-attribute-kind]').forEach((group) => {
      const missing = group.dataset.attributeRequired === 'true' && !group.querySelector('input:checked');
      group.classList.toggle('has-error', missing);
      group.querySelectorAll('input').forEach((input) => input.setAttribute('aria-invalid', missing ? 'true' : 'false'));
      showMessage(group.querySelector('.lr-error'), missing ? 'Please select an option.' : '');
      if (missing) valid = false;
    });
    if (!valid) {
      errorSummary('Please complete the highlighted fields.');
      const first = form.querySelector('[aria-invalid="true"]');
      if (first) first.focus();
    } else errorSummary('');
    return valid;
  }
  async function readResponse(response) {
    let data = {};
    try { data = await response.json(); } catch (_) { /* Use a bounded generic message for non-JSON errors. */ }
    if (!response.ok) {
      let message = 'Your review could not be sent. Please try again.';
      if (typeof data.detail === 'string') message = data.detail.slice(0, 500);
      else if (Array.isArray(data.detail)) {
        for (const detail of data.detail) {
          const name = detail.loc?.at(-1);
          if (errors[name]) fieldError(name, String(detail.msg || 'Please check this field.').slice(0, 300));
        }
        message = 'Please check the highlighted fields and try again.';
      } else if (response.status === 429) message = 'Too many attempts. Please wait before trying again.';
      const error = new Error(message); error.status = response.status; throw error;
    }
    return data;
  }
  function finish() {
    setBusy(false);
    form.hidden = true;
    $('lr-success').hidden = false;
    $('lr-success-message').textContent = 'Your review is awaiting approval.';
    $('lr-review-app').classList.add('lr-form-submitted');
    $('lr-success').focus();
    attachments.forEach(dispose); dispose(avatar);
    receipt = null;
    // The private upload token is intentionally never persisted or exposed in DOM.
  }
  async function uploadRemaining() {
    if (!receipt || busy) return;
    setBusy(true);
    $('lr-upload-recovery').hidden = true;
    errorSummary('');
    const remaining = [...attachments, ...(avatar ? [avatar] : [])].filter((item) => !item.uploaded);
    let done = 0;
    const failures = [];
    for (const item of remaining) {
      showMessage($('lr-submit-progress'), `Uploading ${++done} of ${remaining.length} attachments...`);
      const body = new FormData(); body.append('file', item.file, item.file.name); body.append('kind', item.kind);
      try {
        const response = await fetch(endpoint(`/v1/reviews/${encodeURIComponent(receipt.reviewId)}/media`), { method: 'POST', mode: 'cors', credentials: 'omit', headers: { Authorization: `Bearer ${receipt.uploadToken}`, Accept: 'application/json' }, body });
        await readResponse(response); item.uploaded = true;
      } catch (error) { failures.push(`${item.file.name}: ${error.message || 'Upload failed. Please try again.'}`); }
    }
    setBusy(false); renderAttachments();
    if (failures.length) {
      showMessage($('lr-submit-progress'), 'Your review was received and is awaiting approval.');
      errorSummary(failures.join(' '));
      $('lr-upload-recovery').hidden = false;
    } else finish();
  }
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (busy || receipt || pendingMedia || !validate()) return;
    if (invalidVerificationLink) { errorSummary('This verified review link is invalid. Please reopen the original link provided by the store.'); return; }
    if (!backend) { errorSummary('Review submission is being configured. Please try again shortly.'); return; }
    setBusy(true);
    showMessage($('lr-submit-progress'), 'Submitting your review...');
    const payload = { productId: config.productId, rating: rating(), title: fields.title.value.trim(), body: fields.body.value.trim(), reviewerName: fields.reviewerName.value.trim(), email: fields.email.value.trim(), countryCode: config.countryCode, countryName: config.countryName, visitorId, website: $('lr-website').value };
    const attributeRatings = [];
    const productAttributes = [];
    form.querySelectorAll('[data-attribute-kind]').forEach((group) => {
      const selected = [...group.querySelectorAll('input:checked')];
      if (!selected.length) return;
      const type = group.dataset.attributeKind;
      const value = type === 'multi-value' ? selected.map((input) => input.value) : type === 'centered-range' ? (Number(selected[0].value) - 3) / 2 : Number(selected[0].value);
      const attribute = { title: group.dataset.attributeTitle, type, value, isPrivate: false };
      if (type === 'multi-value') productAttributes.push(attribute); else attributeRatings.push(attribute);
    });
    if (attributeRatings.length) payload.attributesWithRating = attributeRatings;
    if (productAttributes.length) payload.productAttributes = productAttributes;
    if (verificationToken) payload.verificationToken = verificationToken;
    try {
      const response = await fetch(endpoint('/v1/reviews'), { method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'Idempotency-Key': submissionId }, body: JSON.stringify(payload) });
      const data = await readResponse(response);
      if (!data.reviewId || !data.uploadToken || data.status !== 'pending') throw new Error('The server did not confirm your review. Please contact the store before trying again.');
      receipt = { reviewId: data.reviewId, uploadToken: data.uploadToken };
      verificationToken = null;
      setBusy(false);
      if (attachments.length || avatar) await uploadRemaining(); else finish();
    } catch (error) {
      setBusy(false); showMessage($('lr-submit-progress'), '');
      errorSummary(error.message === 'Failed to fetch' ? 'The connection was interrupted. Please try again. Your entered review is still here.' : error.message || 'Your review could not be sent. Please try again.');
    }
  });
  $('lr-retry-uploads').addEventListener('click', uploadRemaining);
  $('lr-finish-without-media').addEventListener('click', () => { if (!busy && receipt) finish(); });
  form.querySelectorAll('[data-attribute-kind] input').forEach((input) => input.addEventListener('change', () => {
    const group = input.closest('[data-attribute-kind]');
    group.classList.remove('has-error');
    group.querySelectorAll('input').forEach((node) => node.setAttribute('aria-invalid', 'false'));
    showMessage(group.querySelector('.lr-error'), '');
  }));
  window.addEventListener('beforeunload', (event) => {
    // A verified link is deliberately memory-only after URL scrubbing. Warn before
    // a reload/navigation would discard it; reopening the original signed link restores it.
    if (busy || receipt || (verificationToken && !form.hidden)) { event.preventDefault(); event.returnValue = ''; }
  });
  window.addEventListener('pagehide', (event) => { if (!event.persisted) { attachments.forEach(dispose); dispose(avatar); } });
  paintStars(rating());
})();
